import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import Header from "src/components/Header";
import * as Logged from "src/redux/logged";
import { withRouter, RouteComponentProps } from "react-router";
import { getPrestation, getProposal } from "src/redux/projects/selectors";

interface Props {
  projectId: number;
  prestationId: number;
  proposalUuid: string;
}
function mapStateToProps(state: AppState, props) {
  return {
    organization: state.user.organization,
    profil: state.user.profil,
    prestation: getPrestation(state.projects, props),
    proposal: getProposal(state.projects, props)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(Logged.logOut())
  };
}

type PropsWithMapStateToProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps &
  Props;

/**
 * Main container of our app, handle common logic:
 * showing available apps etc...
 */
class HeaderContainerToConnect extends React.Component<
  PropsWithMapStateToProps
> {
  render() {
    return (
      <Header
        currentLocation={this.props.location.pathname}
        profil={this.props.profil}
        prestation={this.props.prestation}
        proposal={this.props.proposal}
        organization={this.props.organization}
        logout={this.props.logout}
      />
    );
  }
}

export const HeaderContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HeaderContainerToConnect)
);



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.tsx